// sessionStorage保存当前登录用户信息
export const CURRENT_USER_INFO = 'CURRENT_USER_INFO';

// sessionStorage保存画像页公司基础信息，以减少请求次数
export const COMPANY_INFO_SESSION = 'COMPANY_INFO_SESSION';

export const PERMISSION = 'PERMISSION';

// 分页条数组
export const PAGE_SIZE_OPTIONS = ['10', '20', '30'];

// 默认分页条数
export const PAGE_SIZE = parseInt(PAGE_SIZE_OPTIONS[0], 10);

// 时间格式
export const TIME_FORMAT = 'HH:mm';

// 时间格式
export const YEAR_MONTH = 'YYYY-MM';

// 日期格式
export const DATE_FORMAT = 'YYYY-MM-DD';

// 日期+时间格式
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

// 财务画像页统一的锚点偏移量(px)
export const PICTURE_ANCHOR_OFFSET = 170;

// 偏大偏小中间值
export const MEDIAN_SCORE = 0.6;

// echarts 地图省份名称
export const PROVINCES = [
    '北京',
    '天津',
    '上海',
    '重庆',
    '河北',
    '河南',
    '云南',
    '辽宁',
    '黑龙江',
    '湖南',
    '安徽',
    '山东',
    '新疆',
    '江苏',
    '浙江',
    '江西',
    '湖北',
    '广西',
    '甘肃',
    '山西',
    '内蒙古',
    '陕西',
    '吉林',
    '福建',
    '贵州',
    '广东',
    '青海',
    '西藏',
    '四川',
    '宁夏',
    '海南',
    '台湾',
    '香港',
    '澳门',
    '南海诸岛'
];

// 散点图用的markpoint图标（格式：base64）
export const MARK_POINT_BASE64 =
    'data:image/png;base64,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';

// 大于小于等于比较
export const COMPARE_OPTIONS =  [
    { key: '3', value: '大于' },
    { key: '1', value: '小于' },
    { key: '2', value: '等于' }
];

// 分数排序 [降序，升序]
export const SCORE_SORTS = {
    FRAUD: [1, 2],
    RISK: [3, 4]
};



// WEBPACK FOOTER //
// ./src/constants/common.js